import styled from '@emotion/styled';
import Page from '../../layout/Page';
import First from './first';
import Second from './second';
import ReactPixel from 'react-facebook-pixel';


const Product:React.FC<any> = () => {
  const handleGotoSubscribe = () => {
    window.location.href="/subscribe"
  }

  const handleFlutter = () => {
    ReactPixel.fbq('track', 'StartTrial', {
      "currency": "KRW",
      "value" : 0.00,
      "predicted_ltv" : 10000,
      "event_type" : "productBottom"
    });

    window.location.href="/login"
  }

  return(
    <>
    <Page disable>
      <Container>
        <ImgContainer>
        <Img src="/images/klikkie/main/album.png"/>
        </ImgContainer>
        {/* <Title>더 가까이 두고, <span>&nbsp; 자주 열어보세요</span></Title>
        <First/>
        <Second />
        <ButtonContainer
          className='top'
          onClick={handleGotoSubscribe}
        >
          인화구독 더 알아보기
        </ButtonContainer>
        <ButtonContainer
          className='bottom'
          onClick={handleFlutter}
        >
          인화구독 시작하기
        </ButtonContainer> */}
      </Container>
    </Page>
    </>
  )
}

export default Product;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 120px;
`;

const Title = styled.div`
  display: flex;
  width: 100%;
  height: 70px;
  background-color: #f0Ede7;
  font-size: 18px;
  align-items: center;
  justify-content: center;

  span {
    font-weight: 700;
  }
`;

const BlankContainer = styled.div`
  width: 100%;
  height: 30px;
  background-color: #f0Ede7;
`;

const SubscribeButtonSection = styled.div`
  width: 100%;
  height: 100px;
  background-color: #f0Ede7;
  display: flex;
`;

const SubscribeButton = styled.button`
  margin: 50px auto 0px;
  width: 80%;
  background-color: #d4cd6c;
  height: 50px;
  border-radius: 15px;
  font-size: 18px;
  font-weight: 700;
  color:black;

  span {
    color: rgb(255, 255, 255);
    font-size: 13px;
    font-weight: 400;
  }
`;

const Text2 = styled.div`
  display: flex;
  justify-content: center;
  height: 80px;
  width: 100%;
  padding-top: 15px;
  margin: 0 auto;
  background-color: #f0Ede7;
  color: rgb(189, 189, 189);
`;

const Img = styled.img`
  width: 100%;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 70px;

  color: black;
  font-size: 15px;
  font-weight: 500;
  /* color: white; */
  &.top {
    background-color: #ede3cd;
  }
  &.bottom {
    /* color: white; */
    /* background-color: #e5e0b7; */
    background-color: #e1a349;
  }  
`;

const ImgContainer = styled.div`
  width: 100%;
`